import IntroSmall from './IntroSmall';

export default IntroSmall;
